import { clientWithoutAuth } from "@/axios";

export const passwordReissue = {
  namespaced: true,
  state: {
    open: false,
    password: "",
    passwordConfirm: "",
    pk: "",
    processing: false,
    errorMessages: [],
    error: false
  },
  mutations: {
    initialize(state) {
      state.open = false;
    },
    success(state) {
      state.open = false;
      state.password = "";
      state.passwordConfirm = "";
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    failed(state, { error }) {
      state.processing = false;

      let status = null;
      let errorMessages = [];

      if (error.response) {
        status = error.response.status;
        errorMessages = error.response.data;
      } else {
        status = error.status || null;
        errorMessages = [];
      }

      switch (status) {
        case 500:
          state.errorMessages = {
            email: [errorMessages.message]
          };
          break;

        case 422:
          state.errorMessages = errorMessages;
          break;

        case 401:
          // 何もしない
          break;

        default:
          state.error = true;
          break;
      }
    },
    open(state, { id }) {
      state.open = true;
      state.pk = id;
    },
    close(state) {
      state.open = false;
      state.pk = "";
      state.password = "";
      state.passwordConfirm = "";
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    clear(state) {
      state.pk = "";
      state.password = "";
      state.passwordConfirm = "";
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    processing(state) {
      state.processing = true;
    },
    updatePassword(state, { password }) {
      state.password = password;
    },
    updatePasswordConfirm(state, { passwordConfirm }) {
      state.passwordConfirm = passwordConfirm;
    }
  },
  actions: {
    initialize({ commit }) {
      commit("initialize");
    },
    reissue({ commit, state }, { resourceName }) {
      commit("processing");

      let path = `${resourceName}/reissue`;
      if(state.pk != null){
        path += `/${state.pk}`;
      }

      return new Promise((resolve, reject) => {
        this.$axios // axios
          .put(path, {
            password: state.password
          })
          .then((response) => {
            commit("success");

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });
            reject(error);
          });
      });
    },
    reissueByEmail({ commit, state }, { email }) {
      commit("processing");

      let path = `auth/reissue`;

      return new Promise((resolve, reject) => {
        clientWithoutAuth
          .put(path, {
            email: email
          })
          .then((response) => {
            commit("success");

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });
            reject(error);
          });
      });
    }
  },
  getters: {
    open(state) {
      return state.open;
    },
    password(state) {
      return state.password;
    },
    passwordConfirm(state) {
      return state.passwordConfirm;
    },
    processing(state) {
      return state.processing;
    },
    errorMessages(state) {
      return state.errorMessages;
    },
    pk(state) {
      return state.pk;
    }
  }
};
